import { formatDateTime } from '@/tool/format';

type AnyObject = Record<string, any>;

const KNOWN_FORM_KEYS = [
  'lossRequest',
  'waterRequest',
  'feedingRequest',
  'environmentRecordRequest',
  'medicationRequest',
  'growthSituationRequest',
  'healthRecordRequest',
  'inspectionReportRequest',
  'microscopicRequest',
  'aquaMedication',
  'temporaryCareRecordRequest',
];

function toFormattedDate(value?: any): string {
  try {
    const date = value ? new Date(value) : new Date();
    return formatDateTime(date, 'YYYY-MM-DD HH:mm');
  } catch (_e) {
    return formatDateTime(new Date(), 'YYYY-MM-DD HH:mm');
  }
}

function formatExistingSubmitDatesDeep(obj: any): void {
  if (!obj || typeof obj !== 'object') return;
  if (Array.isArray(obj)) {
    obj.forEach(item => formatExistingSubmitDatesDeep(item));
    return;
  }
  Object.keys(obj).forEach(key => {
    const val = obj[key];
    if (key === 'submitDate') {
      obj[key] = toFormattedDate(val);
    } else if (val && typeof val === 'object') {
      formatExistingSubmitDatesDeep(val);
    }
  });
}

export function ensureSubmitDates(payload: AnyObject): AnyObject {
  if (!payload || typeof payload !== 'object') return payload;

  // 1) 先深度格式化已有的 submitDate
  formatExistingSubmitDatesDeep(payload);

  // 2) 顶层补 submitDate
  if (!('submitDate' in payload)) {
    payload.submitDate = toFormattedDate();
  }

  // 3) 针对已知的表单对象补 submitDate
  KNOWN_FORM_KEYS.forEach(key => {
    const sub = payload[key];
    if (sub && typeof sub === 'object') {
      if (!('submitDate' in sub)) {
        sub.submitDate = toFormattedDate();
      } else {
        sub.submitDate = toFormattedDate(sub.submitDate);
      }
    }
  });

  return payload;
}
